export default __webpack_public_path__ + "static/media/luminr-logo-white.9426cd53.svg";